var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge",class:[`badge--${_vm.view}`]},[(_vm.title)?_c('span',{staticClass:"badge__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }